<template>
	<div>
		<stepper
			v-bind:steps="['Account', 'Cause', 'Preferences', 'Funding']"
			:currentStep="4"
			v-if="onboarding"
		/>
		<screen class="card-view" type="blue" institution="true">
			<template slot="logo">
				<img
					class="header-logo"
					:src="this.cause.icon"
					:style="{
						padding: this.cause.type == 'group' && '5px',
						background: this.cause.type == 'group' && 'white'
					}"
				/>
			</template>
			<template slot="org_name">
				<p
					style="
						font-size: 16px;
						color: white;
						margin-top: 3px;
						text-overflow: ellipsis;
					"
				>
					{{ this.cause.name }}
				</p>
			</template>
			<ui-header @click="onBack" type="light">
				<h2 slot="title">Provide a Donation Source</h2>
				<div class="center">
					<img
						style="
							height: 250px;
							margin-top: -50px;
							margin-bottom: -25px;
						"
						src="@/assets/credit-card-lock.png"
					/>
				</div>
				<p
					style="
						font-size: 16px;
						line-height: 20px;
						margin-top: 0px;
						margin-bottom: 0px;
					"
				>
					Add the card you would like to use to donate your total
					change at the end of each month. You will link accounts to
					RoundUp next.
				</p>
			</ui-header>
			<div class="card-form">
				<p v-if="failedPayout && cardLast4" class="alert alert-info">
					There was a problem with your card **{{ cardLast4 }}. Please
					enter a new card.
				</p>
				<p class="alert alert-info" v-if="cardLast4 && !failedPayout">
					We currently have a {{ cardBrand }} **** {{ cardLast4 }} on
					file.
				</p>
				<form @submit.prevent="onSubmit" id="card">
					<div class="input-row">
						<label id="card_number"></label>
					</div>
					<ui-button
						color="clear-white"
						class="info-button"
						@click="showInfo = !showInfo"
					>
						<i
							class="fas fa-question-circle"
							style="margin-right: 10px"
						></i>
						How does this work?
					</ui-button>
					<funFact title="Note"
						>We process donations and charge your card on the last
						day of the month.</funFact
					>
					<label>
						<ui-button
							color="white"
							native-type="submit"
							:loading="isLoading"
							v-if="cardLast4"
							>Change Card</ui-button
						>
						<ui-button
							color="white"
							native-type="submit"
							:loading="isLoading"
							v-else
							>Attach Card</ui-button
						>
					</label>
				</form>
			</div>
			<modal v-model="showInfo" size="small">
				<h4 style="font-size: 20px">Donation Card</h4>
				<p>
					We process your total RoundUps or monthly minimum (whichever
					is greater) once a month and charge that amount to your
					donation card.
					<br /><br />
					Your donation card can also be linked for rounding up, but
					it is not required.
					<br /><br />
					We process payments through Stripe, the same company that
					does payment processing for Amazon and millions of other
					organizations. So you can be confident your information is
					secure.
				</p>
				<div class="powered-by" />
				<ui-button
					color="white"
					style="
						border: 1px solid #2553cd;
						display: flex;
						width: auto;
						height: 40px;
						border-radius: 20px;
						align-items: center;
						margin-right: 0;
						margin-left: auto;
						font-size: 16px;
					"
					@click="showInfo = !showInfo"
					>Close</ui-button
				>
			</modal>
		</screen>
	</div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { loadScript } from '../../utilities'
import routable from '../../mixins/routable'
import UiButton from '../../ui/Button'
import UiHeader from '../../ui/Header'
import Screen from '../../ui/Screen'
import Stepper from '../../ui/Stepper'
import Modal from '../../ui/Modal.vue'
import FunFact from '../../ui/FunFact.vue'

export default {
	name: 'card-view',
	components: { UiButton, UiHeader, Screen, Stepper, Modal, FunFact },
	mixins: [routable],
	computed: {
		...mapGetters(['fullName', 'failedPayout', 'organizations', 'cause']),
		...mapState({
			cardBrand: ({ me }) => me.current.card_brand,
			cardLast4: ({ me }) => me.current.card_last_four
		})
	},
	data() {
		return {
			isLoading: false,
			onboarding:
				this.$route.params.onboarding || this.$route.meta.onboarding,
			showInfo: false
		}
	},
	methods: {
		...mapActions(['attachCard']),
		onSubmit() {
			this.isLoading = true
			this.stripe
				.createToken(this.card, { name: this.fullName })
				.then((result) => {
					if (result.error) {
						this.isLoading = false
						this.$swal(result.error.message)
						return
					}

					this.attachCard({ token: result.token.id })
						.then(() => {
							this.isLoading = false
							this.next()
						})
						.catch(({ message }) => {
							this.isLoading = false
							this.$swal(message)
						})
				})
		},
		mountStripe() {
			const elements = this.stripe.elements()
			const elementClasses = {
				focus: 'focus',
				empty: 'empty',
				invalid: 'invalid'
			}
			const elementStyles = {
				base: {
					color: '#FFF',
					fontSize: '16px',
					'::placeholder': {
						color: 'rgba(255,255,255,0.8)'
					},
					':focus': {
						color: '#061F61',
						'::placeholder': {
							color: '#1A48C4'
						}
					}
				}
			}

			const cardNumber = elements.create('card', {
				style: elementStyles,
				classes: elementClasses
			})
			cardNumber.mount('#card_number')
			this.card = cardNumber
		},
		onBack() {
			this.navigate(
				{
					name: this.backRoute,
					params: { onboarding: this.onboarding }
				},
				'back'
			)
		}
	},
	mounted() {
		loadScript('https://js.stripe.com/v3/').then(() => {
			this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY)
			this.mountStripe()
		})
	}
}
</script>

<style lang="scss">
.card-view {
	form {
		padding: 20px 0px;
	}
	label {
		display: block;
		button {
			margin-top: 20px;
		}
	}
	.alert {
		background: $green;
		color: $white;
		padding: 20px;
		border-radius: 10px;
		margin-top: 20px;
		&.alert-info {
			color: $navy;
			background: $white;
		}
	}
	.security {
		font-size: 12px;
		color: $white;
		text-align: center;
		padding: 20px 10px;
		max-width: 320px;
		margin: 0 auto;
	}
	.powered-by {
		background-image: url('../../assets/powered_by_stripe.svg');
		background-size: contain;
		background-repeat: no-repeat;
		width: 150px;
		height: 34px;
		display: flex;
	}
}

#card {
	.input-row {
		background: $navy-highlight;
		color: $blue;
		border-width: 0px;
		width: 100%;
		font-size: $font-size;
		margin-bottom: 10px;
		border-radius: 10px;
		outline: none;
		cursor-color: $white;
		label {
			padding: 22px 10px 20px;
			border-radius: 10px;
			&.focus {
				background: #7fa0f8;
			}
			input {
				cursor-color: $white;
			}
		}
	}
	.info-button {
		height: 40px;
		border-radius: 20px;
		margin: 40px;
		margin-left: 0px;
		display: flex;
		width: auto;
		font-size: 14px;
		font-weight: 400;
		justify-content: flex-start;
		flex-direction: row;
		align-items: center;
		text-transform: none;
	}
}
</style>
